import { html, nothing } from 'lit';
import { BoilerplateModal } from './boilerplate_modal';
import { ref } from 'lit/directives/ref.js';

class ModalWishlistMoveProducts extends BoilerplateModal {
  static get properties() {
    return {
      boards: { type: Array },
      currentBoard: { type: Object, state: true },
    };
  }

  constructor() {
    super();
    this.fromBottom = true;
  }

  async handleChange() {
    const wishlist = await window.wishlist.retrieve();
    this.boards = wishlist.boards;
    if (!this.form) return;

    this.currentBoard = this.boards.find((board) => board.id === this.detail?.boardId);
    this.form.requestUpdate();
  }

  toggleModal(e) {
    super.toggleModal(e);

    if (this.form) {
      this.form.resetEmitter();
    }
  }

  async connectedCallback() {
    super.connectedCallback();

    window.eventKeeper?.onEventHeard('wishlist:initialise', this.handleChange.bind(this));

    document.addEventListener('wishlist:initialise', this.handleChange.bind(this));

    document.addEventListener('wishlist:remove', this.handleChange.bind(this));

    document.addEventListener('wishlist:move', this.handleChange.bind(this));

    document.addEventListener('wishlist:update', this.handleChange.bind(this));
  }

  async disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('wishlist:initialise', this.handleChange.bind(this));

    document.removeEventListener('wishlist:remove', this.handleChange.bind(this));

    document.removeEventListener('wishlist:move', this.handleChange.bind(this));

    document.removeEventListener('wishlist:update', this.handleChange.bind(this));
  }

  renderBody() {
    if (!this.detail) {
      return nothing;
    }

    return html` <wishlist-move-to-board-form ${ref((el) => (this.form = el))} .currentBoard=${this.currentBoard || this.detail?.currentBoard} .items=${this.detail?.items} .boards=${this.boards}></wishlist-move-to-board-form>`;
  }
}

window.customElements.get('modal-wishlist-move-to-board') || window.customElements.define('modal-wishlist-move-to-board', ModalWishlistMoveProducts);
